<template>
      <v-row class="component-style" justify="space-around" :style="cssVars">
          <v-col cols="3" :class="[key%2 === 0 ? 'margin-adjust':'no-space']" v-for="(item, key) in profileSteps" :key="key">
              <div v-if="key%2 !== 0">
                <div :class="['key', 'oval', 'centre-align', ((key - 1)/2 + 1) < activeStep ? 'oval-burnt-red' : ((key - 1)/2 + 1) === activeStep ? 'oval-orange' : 'oval-default']">
                    <span class="centre-align">{{(key - 1)/2 + 1}}</span>
                </div>
                <v-spacer class="row-space"></v-spacer>
                <div :class="['details', 'centre-align', ((key - 1)/2 + 1) === activeStep ? 'details-bold' : 'details-normal']">{{ item }}</div>
              </div>
              <div v-else class="link centre-align">
                  <div class="rectangle centre-align"></div>
              </div>
          </v-col>
      </v-row>
</template>
<script>
export default {
    props:{
        activeStep: Number,
        profileSteps: Object,
        componentWidth: String,
    },
    computed: {
        cssVars(){
            return {
                '--component-width': !this.componentWidth ? '721px' : this.componentWidth
            }
        }
    }
}
</script>
<style scoped>

@import url(https://fonts.googleapis.com/css?family=Hind);

.component-style
{
    max-width: var(--component-width);
    margin: auto;
}

.no-space
{
    padding: 0;
    margin:0;
}

.margin-adjust
{
    padding: 0;
    margin-left: -250px;
    margin-right: -250px;
}

@media (max-width: 425px) {
    .margin-adjust
{
    display: none;
}
}

.link
{
      padding-top: 10px
}

.key {
  width: 22px;
  height: 23px;
  font-family: Hind;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  text-align: center;
  color: #000000
}

.oval {
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

.oval-default
{
    background-color: #c2c2c2;
    color: #000000
}

.oval-orange
{
    background-color: #ea7f1d;
    color: #ffffff
}

.oval-burnt-red
{
    background-color: #9c1e23;
    color: #ffffff
}

.details {
  width: 110px;
  height: 23px;
  font-family: Hind;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.details-bold
{
      font-weight: bold
}

.details-normal
{
      font-weight: normal
}

.row-space{
    height: 6px;
}

.rectangle {
  width: 65px;
  height: 2px;
  border-radius: 3px;
  background-color: #c2c2c2;
}

.centre-align
{
    margin: auto
}

</style>